export type FeatureMap = Readonly<{
  'free-chat.response-feedback': boolean
  'free-chat.participants': boolean
  // Opt-out: hides the in-chat header delete (3-dot) menu. Absent/false => shown.
  'free-chat.hide-header-delete': boolean
  // Opt-out: hides the inline tool-calls accordion shown between assistant
  // messages. Absent/false => accordion shown (current behavior).
  'free-chat.hide-debug-traces': boolean
  // Opt-out: hides the post-response action buttons (legacy Coty "Problem
  // solved" etc.) under assistant messages. Absent/false => buttons shown.
  'free-chat.hide-action-buttons': boolean
  // Opt-in: shows a welcome/scope screen in an empty free-mode chat
  // (texts from free_mode.welcome_*). Absent/false => no welcome screen.
  'free-chat.show-welcome': boolean
  // Opt-in: renames the chat from its first user message (for tenants that
  // create chats with a placeholder title). Absent/false => name untouched.
  'free-chat.title-from-first-message': boolean
  // Opt-in: render LaTeX math in bot responses via KaTeX. Absent/false => math
  // is shown as raw text (current behavior). Requires the KaTeX assets in the
  // app's angular.json build (see the treves project).
  'free-chat.katex': boolean
  'input.attachments': boolean
  'module.admin': boolean
  'module.admin.analytics': boolean
  'module.admin.analytics_v2': boolean
  'module.admin.datamodel': boolean
  'module.admin.datasets': boolean
  'module.admin.protocols': boolean
  'module.admin.sites': boolean
  'module.free-mode': boolean
  'module.surveys': boolean
  'module.widget': boolean
  'bot-response.avatar': 'yoshu' | 'teknor' | 'yoshu_v2' | 'yoshu_white'
}>

export type FeatureKey = keyof FeatureMap

export type FeatureValues = FeatureMap[FeatureKey]

export const DEFAULT_FEATURES: FeatureMap = {
  'free-chat.response-feedback': false,
  'free-chat.participants': false,
  'free-chat.hide-header-delete': false,
  'free-chat.hide-debug-traces': false,
  'free-chat.hide-action-buttons': false,
  'free-chat.show-welcome': false,
  'free-chat.title-from-first-message': false,
  'free-chat.katex': false,
  'input.attachments': false,
  'module.admin': false,
  'module.admin.analytics': false,
  'module.admin.analytics_v2': false,
  'module.admin.datamodel': false,
  'module.admin.datasets': false,
  'module.admin.protocols': false,
  'module.admin.sites': false,
  'module.free-mode': false,
  'module.surveys': false,
  'module.widget': false,
  'bot-response.avatar': 'yoshu'
}
